import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// Crear Sucursales User
const NewSucursalesUser = Loadable(lazy(() => import('views/user/SucursalesView/BranchOfficeView/NewBranchOfficeView')));

// List Sucursales User
const ListSucursalesUser = Loadable(lazy(() => import('views/user/SucursalesView/BranchOfficeView/ListBranchOfficeView')));

// Crear Punto Emision User
const NewPuntoEmisionUser = Loadable(lazy(() => import('views/user/SucursalesView/PuntoEmisionView/NewPuntoEmisionView')));

// List Punto Emision User
const ListPuntoEmisionUser = Loadable(lazy(() => import('views/user/SucursalesView/PuntoEmisionView/ListPuntoEmisionView')));

// Crear OrdenCompra User
const NewOrdenCompraUser = Loadable(lazy(() => import('views/user/OrdersView/OrderCompraView/NewOrderCompraView')));

// List OrdenCompra User
const ListOrdenCompraUser = Loadable(lazy(() => import('views/user/OrdersView/OrderCompraView/ListOrderCompraView')));
const ListOrdenCompraTemporalUser = Loadable(lazy(() => import('views/user/OrdersView/OrderCompraView/ListOrderCompraTemporalView')));

// Crear Compra Producto User
const NewCompraUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/NewOrdenView')));

// Recepcion productos inspeccion
const NewRecepcionProductosInspeccionUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/NewRecepcionProductosInspeccionView')));

// Lista y detalle recepcion productos
const ListRecepcionProductosUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/ListRecepcionProductosView')));
const DetalleRecepcionProductosUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/DetalleRecepcionProductosView')));
const ListNovedadesRecepcionProductosUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/ListNovedadesRecepcionProductosView')));
const NovedadesRecepcionProductosUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/NovedadesRecepcionProductos')));

// Crear Compra Servicio User
const NewCompraServicioUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/NewOrdenView')));

// Lista Compra Servicio User
const ListCompraServicioUser = Loadable(lazy(() => import('views/user/OrdersView/ListCompraServiciosView')));

// Crear Warehouse User
const NewWarehouseUser = Loadable(lazy(() => import('views/user/SucursalesView/WarehouseView/NewWarehouseView')));

// List Warehouse User
const ListWarehouseUser = Loadable(lazy(() => import('views/user/SucursalesView/WarehouseView/ListWarehouseView')));

// List Compra User
const ListCompraUser = Loadable(lazy(() => import('views/user/OrdersView/ListCompraView')));

// List Compras Aprobar (Dirección Técnica)
const ListComprasAprobarUser = Loadable(lazy(() => import('views/user/OrdersView/ListComprasAprobar')));

// New Kardex User
const NewKardexUser = Loadable(lazy(() => import('views/user/InventarioView/KardexView/NewKardexView')));

// List Kardex User
const ListKardexUser = Loadable(lazy(() => import('views/user/InventarioView/KardexView/ListKardexView')));

// List Actualizar Lotes
const ListActualizarLotesUser = Loadable(lazy(() => import('views/user/InventarioView/KardexView/ListActualizarLotesView')));
const CruceLotesTemporalesUser = Loadable(lazy(() => import('views/user/InventarioView/CruceLotesTemporalesView')));

// List Kardex Cuarentena User
const ListKardexCuarentenaUser = Loadable(lazy(() => import('views/user/InventarioView/KardexView/ListKardexCuarentenaView')));

// Informe productos en cuarentena
const InformeCuarentenaUser = Loadable(lazy(() => import('views/user/OrdersView/InformeCuarentenaView')));

// Lista informes productos aprobados / rechazados
const ListInformesProductosAprobadosRechazadosUser = Loadable(lazy(() => import('views/user/OrdersView/ListInformesProductosAprobadosRechazadosView')));

// List Kardex Rechazado User
const ListKardexRechazadoUser = Loadable(lazy(() => import('views/user/InventarioView/KardexView/ListKardexRechazadoView')));

// List Kardex Caducado User
const ListKardexCaducadoUser = Loadable(lazy(() => import('views/user/InventarioView/KardexView/ListKardexCaducadoView')));

// List Kardex Aprobar
const ListKardexAprobarUser = Loadable(lazy(() => import('views/user/InventarioView/KardexRequiereAprobarView')));

// List MovimientosKardex User
const ListMovimientoKardexUser = Loadable(lazy(() => import('views/user/InventarioView/MovimientoKardexView/ListMovimientoKardexView')));

// Crear Venta User
const NewVentaUser = Loadable(lazy(() => import('views/user/VentasView/NewVentasView')));

// List Ventas
const ListVentasUser = Loadable(lazy(() => import('views/user/VentasView/ListVentasView')));

// Crear Caja Venta User
const NewCajasVentasUser = Loadable(lazy(() => import('views/user/CajasVentasView/NewCajasVentasView')));

// List Cajas Ventas
const ListCajasVentasUser = Loadable(lazy(() => import('views/user/CajasVentasView/ListCajasVentasView')));

// Toma Fisica Inventarios
const TomaFisicaInventarioUser = Loadable(lazy(() => import('views/user/InventarioView/TomaFisicaView')));

// Devoluciones Ventas
const DevolucionesVentasUser = Loadable(lazy(() => import('views/user/VentasView/DevolucionesView')));

// Busqueda ventas por lote
const DevolucionesVentasBusquedaLoteUser = Loadable(lazy(() => import('views/user/VentasView/DevolucionesView/BusquedaVentasLoteView')));
const BusquedaFacturaMigradaCxcUser = Loadable(lazy(() => import('views/user/VentasView/DevolucionesView/BusquedaFacturaMigradaCxcView')));
const DevolucionesFacturaMigradaUser = Loadable(lazy(() => import('views/user/VentasView/DevolucionesView/DevolucionesFacturaMigradaView')));
const DevolucionesVentaSistemaAnteriorSinCxcUser = Loadable(
    lazy(() => import('views/user/VentasView/DevolucionesView/DevolucionesVentaSistemaAnteriorSinCxcView'))
);

// Crear Compra Activos Fijos FarPro
const NewCompraActivosFijosUser = Loadable(lazy(() => import('views/user/OrdersView/CompraActivosFijosView/NewCompraActivosFijos')));

// List Compra Activos Fijos User
const ListCompraActivosFijosUser = Loadable(lazy(() => import('views/user/OrdersView/CompraActivosFijosView/ListCompraActivosFijos')));

// List Devoluciones Ventas
const ListDevolucionesVentasUser = Loadable(lazy(() => import('views/user/VentasView/ListDevolucionesVentasView')));

// Devoluciones Compras
const DevolucionesComprasUser = Loadable(lazy(() => import('views/user/OrdersView/DevolucionesComprasView')));
const DevolucionesComprasMigradaUser = Loadable(lazy(() => import('views/user/OrdersView/DevolucionesComprasMigradaView')));

// Lista Devoluciones Compras
const ListDevolucionesComprasUser = Loadable(lazy(() => import('views/user/DevolucionesView/ListDevolucionesView')));

// Corregir número / autorización / proveedor de compras
const CorregirDatosCompraUser = Loadable(lazy(() => import('views/user/OrdersView/CorregirDatosCompraView')));

// Devoluciones Compras Busqueda Por lote
const DevolucionesBusquedaLotesComprasUser = Loadable(lazy(() => import('views/user/OrdersView/DevolucionesComprasView/BusquedaDevolucionesComprasLoteView')));

// List CompraTemporales
const ListCompraTemporalUser = Loadable(lazy(() => import('views/user/OrdersView/CompraView/ListCompraTemporalView')));

// Crear Compra Gastos comisiones
const NewCompraGastosComisionesUser = Loadable(lazy(() => import('views/user/OrdersView/ComprasGastosComisionesView/NewCompraGastosComisiones')));

// List Compra Gastos comisiones
const ListCompraGastosComisionesUser = Loadable(lazy(() => import('views/user/OrdersView/ComprasGastosComisionesView/ListCompraGastosComisiones')));

// Crear Gastos Catalogo
const NewGastosCatalogoUser = Loadable(lazy(() => import('views/user/OrdersView/GastosCatalogoView/NewGastosView')));

// List Gastos Catalogo
const ListGastoCatalogoUser = Loadable(lazy(() => import('views/user/OrdersView/GastosCatalogoView/ListGastosView')));

// Move Kardex User
const MoveKardexUser = Loadable(lazy(() => import('views/user/InventarioView/KardexView/MoveKardexWarehouseView')));

const SucursalesRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/new-sucursales/:id_branch_office',
            element: <NewSucursalesUser />
        },
        {
            path: '/user/list-sucursales-view',
            element: <ListSucursalesUser />
        },
        {
            path: '/user/new-punto-emision/:id_punto_emision',
            element: <NewPuntoEmisionUser />
        },
        {
            path: '/user/list-punto-emision-view',
            element: <ListPuntoEmisionUser />
        },
        {
            path: '/user/new-orden-compra/:id_orden_compra',
            element: <NewOrdenCompraUser />
        },
        {
            path: '/user/list-orden-compra-view',
            element: <ListOrdenCompraUser />
        },
        {
            path: '/user/list-orden-compra-temporal-view',
            element: <ListOrdenCompraTemporalUser />
        },
        {
            path: '/user/new-compra/:id_compras/:es_compra',
            element: <NewCompraUser />
        },
        {
            path: '/user/new-recepcion-productos-inspeccion',
            element: <NewRecepcionProductosInspeccionUser />
        },
        {
            path: '/user/list-recepcion-productos',
            element: <ListRecepcionProductosUser />
        },
        {
            path: '/user/detalle-recepcion-productos/:id',
            element: <DetalleRecepcionProductosUser />
        },
        {
            path: '/user/list-novedades-recepcion-productos/:id',
            element: <ListNovedadesRecepcionProductosUser />
        },
        {
            path: '/user/novedades-recepcion-productos/:id/:id_novedad',
            element: <NovedadesRecepcionProductosUser />
        },
        {
            path: '/user/novedades-recepcion-productos/:id',
            element: <NovedadesRecepcionProductosUser />
        },
        {
            path: '/user/new-servicio/:id_compras/:es_compra',
            element: <NewCompraServicioUser />
        },
        {
            path: '/user/new-warehouse-view/:id_warehouse',
            element: <NewWarehouseUser />
        },
        {
            path: '/user/list-warehouse-view',
            element: <ListWarehouseUser />
        },
        {
            path: '/user/list-compra-view',
            element: <ListCompraUser />
        },
        {
            path: '/user/list-compras-aprobar',
            element: <ListComprasAprobarUser />
        },
        {
            path: '/user/new-kardex-view/:id_kardex',
            element: <NewKardexUser />
        },
        {
            path: '/user/list-kardex-view',
            element: <ListKardexUser />
        },
        {
            path: '/user/list-actualizar-lotes-view',
            element: <ListActualizarLotesUser />
        },
        {
            path: '/user/cruce-lotes-temporales',
            element: <CruceLotesTemporalesUser />
        },
        {
            path: '/user/list-kardex-cuarentena-view',
            element: <ListKardexCuarentenaUser />
        },
        {
            path: '/user/informe-productos-cuarentena',
            element: <InformeCuarentenaUser />
        },
        {
            path: '/user/list-informes-productos-aprobados-rechazados',
            element: <ListInformesProductosAprobadosRechazadosUser />
        },
        {
            path: '/user/list-kardex-rechazado-view',
            element: <ListKardexRechazadoUser />
        },
        {
            path: '/user/list-kardex-caducado-view',
            element: <ListKardexCaducadoUser />
        },
        {
            path: '/user/list-movimiento-kardex-view/:id_kardex',
            element: <ListMovimientoKardexUser />
        },
        {
            path: '/user/new-venta-view/:id_ventas',
            element: <NewVentaUser />
        },
        {
            path: '/user/list-ventas-view',
            element: <ListVentasUser />
        },
        {
            path: '/user/new-caja-venta-view/:id_cajas_ventas',
            element: <NewCajasVentasUser />
        },
        {
            path: '/user/list-cajas-ventas-view',
            element: <ListCajasVentasUser />
        },
        {
            path: '/user/toma-fisica-view',
            element: <TomaFisicaInventarioUser />
        },
        {
            path: '/user/list-compra-servicios-view',
            element: <ListCompraServicioUser />
        },
        {
            path: '/user/devoluciones-ventas/:factura/:id_devoluciones_ventas',
            element: <DevolucionesVentasUser />
        },
        {
            path: '/user/busqueda-factura-lote',
            element: <DevolucionesVentasBusquedaLoteUser />
        },
        {
            path: '/user/busqueda-factura-migrada-cxc',
            element: <BusquedaFacturaMigradaCxcUser />
        },
        {
            path: '/user/devoluciones-factura-migrada/:id_ventas/:id_devoluciones_ventas',
            element: <DevolucionesFacturaMigradaUser />
        },
        {
            path: '/user/devoluciones-sistema-anterior-sin-cxc',
            element: <DevolucionesVentaSistemaAnteriorSinCxcUser />
        },
        {
            path: '/user/new-compra-activos-fijos/:id_compras/:es_compra',
            element: <NewCompraActivosFijosUser />
        },
        {
            path: '/user/list-compra-activos-fijos',
            element: <ListCompraActivosFijosUser />
        },    
        {
            path: '/user/list-devoluciones-ventas',
            element: <ListDevolucionesVentasUser />
        },
        {
            path: '/user/devoluciones-compras/:comprobante',
            element: <DevolucionesComprasUser />
        },                
        {
            path: '/user/list-devoluciones-compras',
            element: <ListDevolucionesComprasUser />
        },
        {
            path: '/user/corregir-datos-compra',
            element: <CorregirDatosCompraUser />
        },
        {
            path: '/user/devoluciones-compras-migrada',
            element: <DevolucionesComprasMigradaUser />
        },
        {
            path: '/user/busqueda-devoluciones-compras-lote',
            element: <DevolucionesBusquedaLotesComprasUser />
        },        
        {
            path: '/user/list-compra-temporal/:es_producto',
            element: <ListCompraTemporalUser />
        },  
        {
            path: '/user/new-compra-gastos/:id_compras/:es_compra',
            element: <NewCompraGastosComisionesUser />
        },
        {
            path: '/user/list-compra-gastos',
            element: <ListCompraGastosComisionesUser />
        },    
        {
            path: '/user/new-gastos-catalaogo/:id_gastos_compras_catalogo',
            element: <NewGastosCatalogoUser />
        },
        {
            path: '/user/list-gastos-catalogo',
            element: <ListGastoCatalogoUser />
        },
        {
            path: '/user/move-kardex-view/:id_kardex',
            element: <MoveKardexUser />
        },
        {
            path: '/user/list-kardex-approve-view',
            element: <ListKardexAprobarUser />
        },
    ]
};

export default SucursalesRoutes;